import * as constants from './constants';

const initialState = {
  user: null,
  returnUrl: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.SET_CURRENT_USER:
      return {
        ...state,
        user: action.payload,
      };
    case constants.UPDATE_USER_PROFILE:
      return {
        ...state,
        user: {
          ...state.user,
          profile: JSON.stringify(action.payload),
        }
      };
    default:
      return state;
  }
};

export default reducer;